"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { Socialitem } from "./Socialitem";
import { SocialitemWithimage } from "./SocialitemWithimage";
import * as _utils from "./utils";
import _styles from "./Social.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-973":{"id":"e-973","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-24","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-974"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223930556},"e-974":{"id":"e-974","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-25","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-973"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"45b02e6c-bce3-12cd-d211-bb23dd0617a9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223930559},"e-975":{"id":"e-975","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-24","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-976"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223975769},"e-976":{"id":"e-976","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-25","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-975"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f7ba739e-fcfd-6b2c-975f-681913601607","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223975769}},"actionLists":{"a-24":{"id":"a-24","title":"filter popup [show]","actionItemGroups":[{"actionItems":[{"id":"a-24-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".filter-popup","selectorGuids":["e8ec8c55-aa11-a1fe-c754-f51baf989d52"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701792305692},"a-25":{"id":"a-25","title":"filter popup [hide]","actionItemGroups":[{"actionItems":[{"id":"a-25-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".filter-popup","selectorGuids":["e8ec8c55-aa11-a1fe-c754-f51baf989d52"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701792332125}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function Social({ as: _Component = _Builtin.Block }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component className={_utils.cx(_styles, "card-social")} tag="div">
      <_Builtin.Block className={_utils.cx(_styles, "socialtop")} tag="div">
        <_Builtin.Block
          className={_utils.cx(_styles, "phonetop_left")}
          tag="div"
        >
          <_Builtin.Heading
            className={_utils.cx(_styles, "phoneheader_text")}
            tag="h3"
          >
            {"Socials"}
          </_Builtin.Heading>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "socialstop_right")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "phonetop_iconbtn", "mr-5")}
            data-w-id="f7ba739e-fcfd-6b2c-975f-681913601607"
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-100")}
              width="auto"
              height="auto"
              loading="lazy"
              alt=""
              src="images/66969177ee1a6a8cbeae5e12_inbox_02.svg"
            />
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "filter-popup")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block tag="div">{"All Social"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "chckbox_icon")}
                    tag="div"
                  >
                    <_Builtin.Image
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="images/66968578d5889c78730e31c4_social_fb.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">{"Facebook"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "chckbox_icon")}
                    tag="div"
                  >
                    <_Builtin.Image
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="images/66968578d5889c78730e31b1_social_insta.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">{"Instagram"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "chckbox_icon")}
                    tag="div"
                  >
                    <_Builtin.Image
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="images/66968578d5889c78730e31b2_social_x.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">{"X"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "chckbox_icon")}
                    tag="div"
                  >
                    <_Builtin.Image
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="images/66968578d5889c78730e31c0_social_pinterest.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">{"Pinterest"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "chckbox_icon")}
                    tag="div"
                  >
                    <_Builtin.Image
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="images/66968578d5889c78730e31c1_social_whatsapp.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">{"Whatsapp"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "filter-item")}
              tag="div"
            >
              <_Builtin.FormCheckboxWrapper
                className={_utils.cx(
                  _styles,
                  "checkbox-field",
                  "flex-horixontal"
                )}
              >
                <_Builtin.FormCheckboxInput
                  className={_utils.cx(_styles, "checkbox")}
                  type="checkbox"
                  name="checkbox-4"
                  data-name="Checkbox 4"
                  required={false}
                  checked={false}
                  id="checkbox-4"
                  form={{
                    type: "checkbox-input",
                    name: "Checkbox 4",
                  }}
                  inputType="default"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "checkbox_textcontent")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "chckbox_icon")}
                    tag="div"
                  >
                    <_Builtin.Image
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="images/66968578d5889c78730e31e3_social_youtube.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">{"Youtube"}</_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.FormInlineLabel
                  className={_utils.cx(_styles, "checkbox-label")}
                >
                  {"Checkbox 4"}
                </_Builtin.FormInlineLabel>
              </_Builtin.FormCheckboxWrapper>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "socialbody_div")}
        tag="div"
      >
        <Socialitem />
        <SocialitemWithimage />
        <Socialitem />
        <SocialitemWithimage />
      </_Builtin.Block>
    </_Component>
  );
}
